module.exports = __webpack_public_path__ + "static/img/filtr_varny.334704c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/filtr_varny.png
// module id = tAkQ
// module chunks = 1